exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-about-vssl-js": () => import("./../../../src/pages/about-vssl.js" /* webpackChunkName: "component---src-pages-about-vssl-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-our-values-js": () => import("./../../../src/pages/our-values.js" /* webpackChunkName: "component---src-pages-our-values-js" */),
  "component---src-pages-the-crew-js": () => import("./../../../src/pages/the-crew.js" /* webpackChunkName: "component---src-pages-the-crew-js" */)
}

